import { styled } from "@fluentui/react";
import React from "react";
import { CountryProfileBase } from "./CountryProfile.base";
import { getStyles } from "./CountryProfile.styles";
import {
  CountryProfileProps,
  CountryProfileStyleProps,
  CountryProfileStyles,
  IRoles
} from "./CountryProfile.types";

export const CountryProfile: React.FunctionComponent<CountryProfileProps> =
  styled<CountryProfileProps, CountryProfileStyleProps, CountryProfileStyles, IRoles>(
    CountryProfileBase,
    getStyles
  );
